'use client';

import { ContactSupportSection, PageBuilderPage } from '@workspace/widgets';

type GenericPageLike = {
  _id?: string;
  [key: string]: unknown;
};

export default function ClientAboutUsPage({ page }: { page: GenericPageLike | null | undefined }) {
  if (!page?._id) return null;

  return (
    <div>
      <PageBuilderPage page={page as any} />
      <ContactSupportSection locator={{ docId: page._id }} />
    </div>
  );
}
